import { cn } from '@mint-lib/tw-utils';

type Props = {
  children: React.ReactNode;
  className?: string;
};
const ChartTooltip = ({ className, children }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-1 rounded-sm bg-ui-primary p-2 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.25)] outline-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ChartTooltip;
